import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLaptopCode,
  faRobot,
  faChartLine,
  faCloud,
} from '@fortawesome/free-solid-svg-icons';
import './style.css';

const servicesSection = [
  {
    title: 'Web Development',
    icon: faLaptopCode,
    description: 'Build fast, secure, and scalable websites that drive real results.',
    ariaLabel: 'Learn about our web development services'
  },
  {
    title: 'AI Solutions',
    icon: faRobot,
    description: 'Leverage intelligent automation to save time and boost efficiency.',
    ariaLabel: 'Learn about our AI solutions'
  },
  {
    title: 'Digital Strategy',
    icon: faChartLine,
    description: 'Grow your brand with data-driven marketing and sharp positioning.',
    ariaLabel: 'Learn about our digital strategy services'
  },
  {
    title: 'Cloud & Hosting',
    icon: faCloud,
    description: 'Rely on robust infrastructure and expert technical support 24/7.',
    ariaLabel: 'Learn about our cloud and hosting services'
  },
];

function ServicesSection() {
  return (
    <section id="services" className="services-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 services-title">
            What We Do
          </h2>
          <p className="lead services-lead">
            High-impact services to elevate your business
          </p>
        </div>

        <Row className="gy-4">
          {servicesSection.map(({ title, icon, description, ariaLabel }) => (
            <Col xs={12} sm={6} md={3} key={title} className="mb-4">
              <div
                className="service-card"
                role="group"
                aria-label={ariaLabel}
              >
                <div
                  className="icon-circle"
                  aria-hidden="true"
                >
                  <FontAwesomeIcon icon={icon} />
                </div>
                <h5 className="fw-bold mb-3">{title}</h5>
                <p className="service-description">
                  {description}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default ServicesSection;
